import DatePickerBox from "controls/datePickerBox/datePickerBox";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent, useEffect } from "react";
import { Col, Form } from "react-bootstrap";
import { disabledDaysRange, maxValidSince, minValidSince } from "utils/dateUtils";
import ValiditySelectViewModel from "viewModels/eshop/order/components/validitySelectViewModel";
import { DataTestIds } from "data-test-constants";
import { isSafari9OrLess } from "utils/iOS";
import { useIdleTimer } from "react-idle-timer";
import { startOfDay, subDays } from "date-fns";
import { dateToIsoDate } from "../../../../utils/dateUtils";

const ValiditySelect: FunctionComponent<{
  vm: ValiditySelectViewModel;
  showLabel?: boolean;
}> = observer(({ vm, showLabel = true }) => {
  const ta = (code: string) => {
    return vm.localizationService.translateAttribute("orderItem", code);
  };

  const { getRemainingTime } = useIdleTimer({
    onIdle: vm.handleIdle,
    onActive: vm.clearTimeoutInterval,
    timeout: vm.IDLE_TIMER_TIMEOUT,
    debounce: vm.IDLE_TIMER_DEBOUNCE,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      Math.ceil(getRemainingTime() / 1000) * 1000 + vm.IDLE_PROMPT_TIMEOUT;
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const errorLocalization = (code: string) => {
    if (["min", "max"].includes(code)) {
      if (code === "max" && vm.postponedValidityRule?.postponedValidityMaxDays) {
        return vm.localizationService
          .translateAttribute("validSince", code)
          .replace("%amount%", `${vm.postponedValidityRule.postponedValidityMaxDays}`);
      }
      return vm.localizationService.translateAttribute("validSince", code).replace("%amount%", `${30}`);
    } else if (code === "invalidDateFormat") {
      return vm.localizationService.translateGeneral(code);
    } else {
      return code;
    }
  };

  const disabledDays = disabledDaysRange(vm.serverTime, vm.serverTime, vm.postponedValidityRule?.postponedValidityMaxDays);
  let fromMonth = isSafari9OrLess ? disabledDays.before : minValidSince();
  let toMonth = disabledDays.after
    ? disabledDays.after
    : maxValidSince(fromMonth, vm.postponedValidityRule?.postponedValidityMaxDays);
  if (vm.chargeOrderChargeItem.validSince) {
    if (vm.chargeOrderChargeItem.validSince < fromMonth) {
      fromMonth = vm.chargeOrderChargeItem.validSince;
    } else if (vm.chargeOrderChargeItem.validSince > toMonth) {
      toMonth = vm.chargeOrderChargeItem.validSince;
    }
  }
  const datePicker = (
    <DatePickerBox
      id={DataTestIds.VALID_SINCE_INPUT}
      errorLocalization={errorLocalization}
      target={vm.chargeOrderChargeItem}
      disabledDays={disabledDays}
      fromMonth={subDays(fromMonth, 1)}
      today={startOfDay(vm.serverTime)}
      toMonth={toMonth}
      property="validSince"
      placeholder={vm.localizationService.translateGeneral("datepicker.placeholder")}
      datePickerLocalization={vm.localizationService.datePickerLocalization}
      forSale={true}
      autoComplete="off"
    />
  );

  return (
    <Form.Group controlId={DataTestIds.VALID_SINCE_INPUT} as={Col} sm={12} xl={6}>
      {showLabel && <Form.Label>{ta("validSince")}</Form.Label>}
      {datePicker}
    </Form.Group>
  );
});

export default ValiditySelect;
